module.exports = {
  appMobileInstallation: {
    hide: 'Hide',
    title: 'Get the Keelearning app!',
    slug_title: 'Your App-ID',
  },
}
